import React from 'react'
import './WelcomePage.css'

const WelcomePage = () =>{
    return(
        <div className="form-welcome">
            <h2 className="welcome-heading">Your Movie night robot</h2>
                <p>Get your cozy mood on and find out what you will be doing tonight</p>
        </div>
    )
}

export default WelcomePage